import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9nsfnkqwuw: FaireBrandEntity = {
  token: "b_9nsfnkqwuw",
  type: "brand",
  name: "Cutter & Buck",
  avatarUrl:
    "https://cdn.faire.com/fastly/6424f4d7771b5f9352bb8e99eb2cb42e06b9f1917db625c795abe34ddce51eaa.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/f3c318a0c2d039b9efed39d46d629c83a0e6afbe0b0a3e0392f0191f6a4bf97a.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/6424f4d7771b5f9352bb8e99eb2cb42e06b9f1917db625c795abe34ddce51eaa.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f3c318a0c2d039b9efed39d46d629c83a0e6afbe0b0a3e0392f0191f6a4bf97a.jpeg",
  location: "Renton, WA, USA",
  minimumOrderDollars: 150,
  rating: 4.8,
  reviewCount: 118,
  isInsider: true,
  description:
    "We are the bigger-the-better idea people and the up-for-anything instigators. Working hard to improve the world around us, we seek new frontiers to fuel our ingenuity as pioneers. We invite you to push beyond what is, to what could be in the work you do and the life you choose.\n\nOur Cutter & Buck and Clique iconic clothing is crafted for your active lifestyle, engineered for exceptional versatility so it will be perfect for work, work from home, travel, date night, golf, walking, boating, hiking,  and entertaining. Our clothing is thoughtfully engineered with performance features like moisture wicking, stretch, UPF for sun protection, and with easy care and time saving features such as durable collars, added spandex, and blended fabrics that are comfortable and stylish. At Cutter & Buck we share your commitment to sustainability, with our commitment to sustainable products, sustainable operations, and sustainable production. When you choose Cutter & Buck/Clique clothing, you are getting the genuine spirit of the Pacific Northwest.\n\nPlease check out our blog! https://blog.cutterbuck.com/?_ga=2.22061755.[redacted-phone].[redacted-phone]-29553399.[redacted-phone]",
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:02:45.866Z",
    importedBy: "entity-db-cli",
  },
};
